import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Checkbox, Divider, Stack, Tooltip, Typography} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {constance} from "../../common/constance/constance";
import {RootState} from "../../reducer";
import {common} from "../../common/common";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";


/* 도서대여 페이지 알람 */
export default function OneLineReviewListDialog(props: { state: any, setState: any }) {
    console.log('[OneLineReviewListDialog]');

    const [state, setState] = useState({
        selectedReviewId: ''
    });

    const handleClose = () => {
        props.setState({
            ...props.state,
            openReviewDialog: false
        })
    };

    function deleteReview(book: any) {
        console.log(book);
    }

    function openUpdateReview(review: any) {
        setState({
            ...state,
            selectedReviewId: review.book
        })
    }

    const commonData = useSelector((state: RootState) => state.commonData);


    return (
        <Box sx={{}}>
            <Dialog open={props.state.openReviewDialog} onClose={handleClose} sx={{maxHeight: '100vh',}}>
                <DialogTitle sx={{display: 'flex', justifyContent: 'center'}}>
                    <Typography variant={"h6"}>한줄평</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{minWidth: 400}}>
                        <Stack sx={{mt: 1, backgroundColor: 'var(--scc-surface)', p: 2, borderRadius: 2}}>
                            <Divider/>
                            {
                                props.state.reviews.map((review: any, index: number) => {
                                    return (
                                        <>
                                            <Box sx={{width: 1, display: 'flex', p: 1, alignItems: 'center'}}>
                                                <Box sx={{width: 0.6, display: 'flex', alignItems: 'center'}}>
                                                    {
                                                        state.selectedReviewId == review.book?
                                                            <TextField >
                                                                {review.content}
                                                            </TextField>
                                                            :
                                                            <Typography variant={"subtitle1"}>
                                                                {review.content}
                                                            </Typography>
                                                    }

                                                </Box>
                                                <Stack sx={{width: 0.4}}>
                                                    <Box sx={{width: 1}}>
                                                        <Typography variant={"subtitle2"} align={"right"}>
                                                            {`${review.writer.departmentName} ${review.writer.name}`}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{width: 1}}>
                                                        <Typography variant={"subtitle2"} align={"right"}>
                                                            {`${common.getTimeFormatYMD(review.createdAt)}`}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                                {/*{
                                                    commonData.user._id == review.writer._id?
                                                            <Box sx={{pl: 1, display: 'flex'}}>
                                                                <Box sx={{width: 1}}>
                                                                    <Tooltip title={'수정'}>
                                                                        <ModeEditIcon color={'action'}
                                                                                      onClick={() => openUpdateReview(review.book)}
                                                                                      sx={{cursor: 'pointer'}}/>
                                                                    </Tooltip>
                                                                </Box>
                                                                <Box sx={{width: 1}}>
                                                                    <Tooltip title={'삭제'}>
                                                                        <DeleteIcon color={'error'}
                                                                                    onClick={() => deleteReview(review.book)}
                                                                                    sx={{cursor: 'pointer', ml: 1}}/>
                                                                    </Tooltip>
                                                                </Box>
                                                            </Box>

                                                        :
                                                        <></>
                                                }
*/}
                                            </Box>
                                            <Divider/>
                                        </>
                                    )
                                })
                            }
                        </Stack>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </Box>
    );
}
